export default {
    data() {
        return {
            dateFrom: "-",
            dateTo: "-"
        }
    },
    computed: {
        validDate: function () {
            if (this.dateTo !== '-' && this.dateFrom !== '-') {
                return this.dateFrom <= this.dateTo
            } else {
                return true
            }
        }
    }
}
